import React, { useEffect } from "react"
import { resolvePermisos } from "helpers/general_helpers"

import { Switch, BrowserRouter as Router } from "react-router-dom"
import { basePath, withBase } from "constants/basePath"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "routes/route"

import HorizontalLayout from "components/HorizontalLayout/"
import NonAuthLayout from "components/NonAuthLayout"
import Bundary from "./Bundary"

import { initAxiosInterceptors, deleteToken } from "helpers/auth_helpers"

import userStore from "./userStore"
import newStore from "./newStore"

import { getUser, getProfiles, getMenu } from "./api"

import CacheBuster from "react-cache-buster"
import packageInfo from "../package.json"

// Import scss
import "./assets/scss/theme.scss"
import toastHandler from "toastHandler"

import "leaflet/dist/leaflet.css"
import "leaflet-draw/dist/leaflet.draw.css"

import "assets/css/workflow-designer.css"

initAxiosInterceptors()

const App = () => {
  const setUser = userStore(state => state.setUser)
  const setError = toastHandler(state => state.setError)

  const logoutUser = () => {
    deleteToken()
    localStorage.clear()
    window.location.href = withBase("/iniciar-sesion")
  }

  useEffect(() => {
    const token = localStorage.getItem("authUser")
    if (!token) {
      // No hay token — el usuario no está logueado, no hacer llamadas API
      return
    }

    userStore.setState({ loading: true })

    getUser()
      .then(resp => {
        setUser(resp)
        // setUser({...resp, roles: ["ROLE_DEV_EWAN_OFICCOMERCIAL"]})

        getProfiles()
          .then(profiles => {
            const roles = resp?.roles

            const { permisos, perfiles, hasAccess, admin } = resolvePermisos(
              roles,
              profiles,
            )
            if (!hasAccess) {
              return logoutUser()
            }

            // Extraer flags de acceso para "permisos por perfil" desde el array de permisos resueltos.
            const permisoPerfil = (permisos || []).find(
              p =>
                (p.nombreObjeto || "").toLowerCase() ===
                "seguridad->permisos por perfil",
            )
            const modificacion = permisoPerfil?.modificacion === true
            const consulta = permisoPerfil?.consulta === true

            userStore.setState({
              permisos,
              perfiles,
              roles,
              modificacion,
              consulta,
              admin,
              loading: false,
            })
          })
          .catch(err => {
            setError(err)
            userStore.setState({ loading: false })
          })
      })
      .catch(err => {
        setError(err)
        userStore.setState({ loading: false })
      })

    getMenu()
      .then(res => {
        const sorted = [...res].sort((a, b) => a.order - b.order)
        newStore.setState({
          navbar: sorted.map(item => ({
            ...item,
            show: false,
            childs: [...item.childs]
              .sort((a, b) => a.order - b.order)
              .map(i => ({ ...i, show: false })),
          })),
        })
      })
      .catch(setError)

    userStore.setState({ changes: false })
  }, [localStorage.getItem("authUser")])

  return (
    <>
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={false} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
      >
        <Router
          basename={basePath() || "/"}
          getUserConfirmation={() => {
            /* Empty callback to block the default browser prompt */
          }}
        >
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                exact
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={HorizontalLayout}
                component={route.component}
                permissionBy={route.permissionBy}
                rolesRequeridos={route.rolesRequeridos}
                objetoRequerido={route.objetoRequerido}
                accionRequerida={route.accionRequerida}
                publico={route.publico}
                key={idx}
                error={route.error}
                isAuthProtected={true}
                exact
              />
            ))}
          </Switch>
          <Bundary />
        </Router>
      </CacheBuster>
    </>
  )
}

export default App
